import PropTypes from 'prop-types';

import { getMonthlyPrice } from '@spotahome/marketplace-common/src/utils/homecards';
import { HorizontalScrollList } from '@spotahome/ui-library';
import { HomecardFormatter } from '@spotahome/ui-library/src/tenant/utils/images';

import './HomecardScrollList.scss';

export const formatHomecardData = homecard => ({
  ...homecard,
  photos: HomecardFormatter.getPhotos(
    homecard.photoIds,
    homecard.otherPropertyPhotoIds
  ),
  photoUrls: HomecardFormatter.getPhotoUrls(homecard.photoIds),
  monthlyPrice: getMonthlyPrice(homecard.displayPrice)
});

const HomecardScrollList = ({
  homecards,
  listClassName,
  listItemClassName = 'homecard-scroll-list__item',
  renderItem
}) => (
  <HorizontalScrollList
    items={homecards}
    listClassName={listClassName}
    listItemClassName={listItemClassName}
    renderItem={(homecard, handleItemClick, position) =>
      renderItem(formatHomecardData(homecard), position, handleItemClick)
    }
  />
);

HomecardScrollList.propTypes = {
  homecards: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string }))
    .isRequired,
  listClassName: PropTypes.string,
  listItemClassName: PropTypes.string,
  renderItem: PropTypes.func.isRequired
};

export default HomecardScrollList;
